import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../hooks/useAdmin';

/**
 * Route guard for standalone admin-only pages (outside the /admin AdminLayout).
 * Renders children only for admins; everyone else is redirected home. Mirrors the
 * gate AdminLayout applies to the /admin routes.
 */
export default function AdminGate({ children }) {
  const { isAdmin, loading } = useAdmin();
  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#1c1c1a',
          color: '#f3efe6',
          padding: 24,
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        Loading…
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}
